import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Notification } from './notifications.interface';
import { notificationAdapter, NotificationsState } from './notifications.reducer';

export const {
	selectEntities: selectNotificationEntities,
	selectAll: selectAllNotifications,
	selectTotal: notificationsCount
} = notificationAdapter.getSelectors();

export const getNotificationsState = createFeatureSelector<NotificationsState>('notifications');
export const getNotificationEntities = createSelector(getNotificationsState, selectNotificationEntities);
export const getAllNotifications = createSelector(getNotificationsState, selectAllNotifications);
export const getNotificationsCount = createSelector(getNotificationsState, notificationsCount);

export const getVisibleNotifications = createSelector(
	getAllNotifications,
	(notifications: Notification[]) => notifications.filter(notification => !notification.isDismissed)
);

export const getVisibleNotificationsByChannel = (channels: string[]) => createSelector(
	getVisibleNotifications,
	(notifications: Notification[]) => notifications.filter(notification => channels.includes(notification.channel))
);
